import { ReportService } from '@/app/reports/share/report.service'
import { ref } from '@vue/composition-api'
import store from '@/store'
import {reFilterSupportDevices,reFilterGeofences,owners,devices,contracts,geofences} from '@/app/reports/share/helper'

export default function reportForm() {

  const  areas_owners=ref([]);
  const  areas_contracts=ref([]);


   

  const type = ref('inside')

  ReportService.getDevicesOptions({
    type:'device',
    isSupport:true,
    user: store.state.auth.userData.id
  }).then(response => devices.value = response.data.map((d)=>({id:d.device_id,"name":d.name})))


  ReportService.getAreasOptions({
    type:'geofence',
    user: store.state.auth.userData.id
  }).then(response => geofences.value = response.data.map((d)=>({id:d.geofence_id,"name":d.name})))

  ReportService.getDevicesOptions({
    type:'contract',
    user: store.state.auth.userData.id
  }).then(response =>{contracts.value = response.data})

  ReportService.getDevicesOptions({
    type:'user',
  
    user: store.state.auth.userData.id
  }).then(response =>{ 
    areas_owners.value = response.data;
    owners.value = response.data;
  })


  
  ReportService.getDevicesOptions({
    type:'contract',
    user: store.state.auth.userData.id
  }).then(response =>{
 
    areas_contracts.value = response.data
  contracts.value = response.data

})



  return {
    devices,
    geofences,
    type,
    owners,
    contracts,
    areas_owners,
    areas_contracts,
    reFilterSupportDevices,
    reFilterGeofences
  }
}
